exports.default = {
  'drag_files_here_or': 'Drag files here or',
  'click_to_upload': 'click to upload',
  'supports_pdf_files_single_file_size_no_more_than_20m': 'Supports PDF files, single file size no more than 20MB, scanned copies are not supported, up to 50 files can be selected at once',
  'file_upload': 'File upload',
  'uploading': 'Uploading',
  'upload_task_completed': 'Upload task completed',
  'upload_not_completed_cancel_all_ongoing_uploads': 'Upload not completed. Do you want to cancel all ongoing uploads?',
  'tips': 'Tips',
  'cancel_upload': 'Cancel upload',
  'continue_upload': 'Continue upload',
  'executing': 'Executing...',
  'upload_task_in_progress': 'Upload task in progress...',
  'each_time_select_max_files': 'You can select up to {multiLimit} files at a time, current selected file count is {filesLength}',
  'file_type_error': 'File type error!',
  'upload_avatar_image_can_only_be_jpg_or_png_format': 'Upload avatar image can only be JPG or PNG format!',
  'upload_image_size_cannot_exceed_10m': 'Upload image size cannot exceed 10MB!',
  'upload_file_size_cannot_exceed_20m': 'Upload file size cannot exceed 20MB!',
  'uploaded_tasks_total_kb': 'Uploaded {uploadFiled} tasks, total {uploadSize} KB'
}
